export enum ReferralsImportSource {
  LinkedIn = 'linkedin',
  Google = 'google',
}

export enum ReferralsImportStatus {
  Initialized = 'initialized',
  Failed = 'failed',
  Completed = 'completed',
}

export interface ReferralsImport {
  id: number;
  completedAt: string;
  source: ReferralsImportSource;
  status: ReferralsImportStatus;
}

export interface ReferralsLastImport extends ReferralsImport {
  data: {
    total: number;
    failure: number;
    error: string;
    count: number;
  };
}

export enum ImportContext {
  ImportNewConnections = 'importNewConnections',
  ReimportConnections = 'reimportConnections',
}
